module.exports = __webpack_public_path__ + "img/lucky777bet.9fcb9263.png";